import { createFileRoute } from '@tanstack/react-router';

import { AdminCompetitorsPage } from '@/components/admin/competitors-page';
import { adminHead } from '@/lib/seo';
import {
    adminCompetitorsDailyStatsFn,
    adminListCompetitorsFn,
} from '@/server/functions/competitors';

export const Route = createFileRoute('/_admin/admin/competitors')({
    component: CompetitorsRoute,
    head: () => adminHead('מתחרים', '/admin/competitors'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async () => {
        const [initial, chart] = await Promise.all([
            adminListCompetitorsFn({ data: { limit: 50 } }),
            adminCompetitorsDailyStatsFn({ data: {} }),
        ]);
        return { initial, chart };
    },
});

function CompetitorsRoute() {
    const { initial, chart } = Route.useLoaderData();
    return <AdminCompetitorsPage initial={initial} chart={chart} />;
}
